import { MultiLangString } from '@/models/general';

export type Webshop = {
    id?: string;
    liftOperatorId: string;
    vanityIdentifier: string;
    integrationToken: string;
    primaryColor: string;
    primaryLightColor: string;
    imprintUrl: MultiLangString;
    dataPrivacyUrl: MultiLangString;
    termsAndConditionsUrl: MultiLangString;
    headerImageUrl: string;
    logoUrl: string;
    tagManagerCode: string;
    dayTicketsButtonText: MultiLangString;
    seasonTicketsButtonText: MultiLangString;
    infoText: MultiLangString;
    buttonTextColor: string;
    buttonBackgroundColor: string;
    filterTextColor: string;
    filterBackgroundColor: string;
};

export type CreateWebshop = Omit<Webshop, 'id'>;

export const isOfTypeWebshop = (
    webshop: Webshop | CreateWebshop
): webshop is Webshop => !!webshop?.['id'];
